import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/class-control";

const tagVariants = cva(
  "inline-flex items-center justify-center rounded-[30px] px-[60px] py-[6px] font-['Plus_Jakarta_Sans'] font-semibold text-[12px] text-center leading-[1.4]",
  {
    variants: {
      variant: {
        primary: "bg-[#7846FF] text-[#F5F2FF]",
        outline: "border border-[#7846FF] text-[#F5F2FF] bg-transparent",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  }
);

export interface ProjectTagProps extends VariantProps<typeof tagVariants> {
  label: string;
  className?: string;
}

export function ProjectTag({ label, variant, className }: ProjectTagProps) {
  return (
    <span className={cn(tagVariants({ variant }), className)}>
      {label}
    </span>
  );
}
